import { Component, OnInit } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router , NavigationEnd} from '@angular/router';

import {AppSettings} from '../../app-settings';
import {HttpClientService} from '../../Services/http-client.service';
import {UserService} from '../../Services/user.service';

@Component({
  selector: 'app-learning-level-details',
  templateUrl: './learning-level-details.component.html',
  styleUrls: ['./learning-level-details.component.css']
})


export class LearningLevelDetailsComponent implements OnInit {

  constructor(private httpClientService: HttpClientService, private route: ActivatedRoute, private userService: UserService, router:Router) {}

  ngOnInit(){}

}
